module.exports = __webpack_public_path__ + "static/media/kjøtt.7735b0d7.mp3";